import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { uniformeModulo } from 'src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule';
import { ResponseSizeModel } from "../model/responseSizeModel";

@Injectable({
  providedIn: 'root'
})
export class SizeService {

  diccionarioUrl: any;
  urlUniforme: string;
  
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlUniforme = this.utilServices.getUniforme();
    this.diccionarioUrl = uniformeModulo.url.uniforme;
  }

  findSizeByGroup(identificador: string) {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.size +'/'+ identificador);
  } 

  createEditSize(groupTalla: string, size: ResponseSizeModel){
    return this.commom.peticionPostConHeader(this.urlUniforme + this.diccionarioUrl.size +'/'+ groupTalla, size);
  }

  deleteSize(groupTalla: string, codSize: string) {
    return this.commom.peticionDeleteConHeader(this.urlUniforme + this.diccionarioUrl.size +'/'+ groupTalla +'/'+codSize);
  } 

}
